import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PropostaComercialService {
  private _apiUrl = environment.apiUrl + "/v1/PropostaComercial";

  constructor(private http: HttpClient) { }

  atualizarPropostaComercial(id:string, descricao:string, observacao:string, configuracao:string): Observable<string> {
    let proposta = {
      id,
      descricao,
      observacao,
      configuracao
    }
    return this.http.put<string>(`${this._apiUrl}`, proposta);
  }

  consultarPropostaComercial(id:string): Observable<any> {
    return this.http.get<any>(`${this._apiUrl}/${id}`);
  }
  
}
